import React, { useState } from 'react'
import styled from 'styled-components'
import { EditAvatarSvg } from '~/components/icons'
import { uploadFile } from '~/common/helpers'
import { UPDATE_WORKER_AVATAR } from '~/common/apollo'
import { useMutation } from '@apollo/client'
import { observer } from '~/common/mobx.decorator'
import { notifyStore } from '~/stores'
import { CircularProgress } from '@material-ui/core'
import { eventBus } from 'mobx-event-bus2'
import { EVENTS } from '~/common/constants'
import { careStore } from '~/companies/care/care.store'
import { ImageLoadInit } from '~/components/image/image-load-init.component'

const AvatarImg = styled.div`
	font-size: 16px;
	padding: 2px;
	background: ${({ theme }) => theme.colors.primary.main};
	text-align: center;
	color: white;
	border-radius: 50%;
	font-weight: 600;
`

const EditAvatarWrapper = styled.div`
	right: 0px;
	cursor: pointer;
	position: absolute;
	top: 64px;
	background: ${({ theme }) => theme.colors.primary.main};
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	width: 35px;
	height: 35px;
	border: 3px solid white;
	svg {
		width: 16px;
		height: 16px;
	}
`
const MAXIMUM_FILE_SIZE_10MB = 10 * 1000 * 1000

export const UserAvatar = observer(({ isAllowShowEditAvatar, firstName, lastName, isShowAvatar = true, ...rest }) => {
	const { workerAvatar } = careStore
	const [loading, setLoading] = useState(false)
	const [handleUpdateAvatar] = useMutation(UPDATE_WORKER_AVATAR, {
		onCompleted: async (data) => {
			await careStore.fetchWorkerAvatar()
		},
	})
	const handleUploadAvatar = () => {
		const fileInput = document.createElement('input')
		fileInput.type = 'file'
		fileInput.accept = 'image/*'
		fileInput.addEventListener('change', async () => {
			const file = fileInput.files[0]
			if (file.size >= MAXIMUM_FILE_SIZE_10MB) {
				return eventBus.post(EVENTS.notifyStore.fireError, { message: '$ERRORS.MAXIMUM_FILE_SIZE_AVATAR' })
			}
			try {
				await setLoading(true)
				const res = await uploadFile(file)
				const { signedBlobId } = res
				await handleUpdateAvatar({
					variables: {
						avatar: {
							fileSignedBlobId: signedBlobId,
						},
					},
				})
				await setLoading(false)
				await notifyStore.success('Upload avatar success')
			} catch (error) {
				console.error(error)
				await notifyStore.error(error.message)
			}
		})
		fileInput.click()
	}
	return (
		<>
			{!!loading ? (
				<AvatarImg {...rest}>
					<CircularProgress color={'white'} />
				</AvatarImg>
			) : !!workerAvatar && !loading && isShowAvatar ? (
				<ImageLoadInit
					style={{
						borderRadius: '50%',
						objectFit: 'none',
						boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
					}}
					alt="completed"
					src={workerAvatar}
					{...rest}
				/>
			) : (
				<AvatarImg {...rest}>
					{firstName && firstName[0].toUpperCase()}
					{lastName && lastName[0].toUpperCase()}
				</AvatarImg>
			)}

			{isAllowShowEditAvatar && (
				<EditAvatarWrapper onClick={handleUploadAvatar}>
					<EditAvatarSvg />
				</EditAvatarWrapper>
			)}
		</>
	)
})

UserAvatar.defaultProps = {
	firstName: '',
	lastName: '',
}
